<template>
  <Transition name="fade">
    <div
      v-if="shouldShowTrigger"
      class="trigger"
      role="button"
      tabindex="0"
      @click="handleButtonClick"
      @keydown.enter="handleButtonClick"
    >
      <span class="trigger__label">Get {{ bonus }} off</span>
      <button
        type="button"
        class="trigger__close"
        aria-label="Dismiss offer"
        @click.stop="hideTrigger"
      >
        <i class="icon icon-cross" />
      </button>
    </div>
  </Transition>
</template>

<script>
import { getSignUpBonus } from "@/config";
import { mapGetters, mapActions } from "vuex";
import { getFeatureToggles } from "@/helpers/featureToggles.js";
export default {
  name: "DataCollectionTrigger",
  computed: {
    ...mapGetters("app", [
      "currencyCode",
      "dataCollectionDismissed",
      "dataCollectionTriggerDismissed",
    ]),
    ...mapGetters("auth", ["isLoggedIn"]),
    isNewDataCollection() {
      const { dataCollectionVersion = 6 } = getFeatureToggles();
      return dataCollectionVersion === 3;
    },
    shouldShowTrigger() {
      return (
        this.isNewDataCollection &&
        !this.isLoggedIn &&
        this.bonus &&
        this.dataCollectionDismissed &&
        !this.dataCollectionTriggerDismissed
      );
    },
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const featureToggles = getFeatureToggles();
      const amount = getSignUpBonus(this.currencyCode, featureToggles);
      if (typeof amount === "string" && amount.endsWith("%")) {
        return amount;
      }
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    ...mapActions("app", ["setUserPreferences"]),
    handleButtonClick() {
      this.setUserPreferences({
        key: "dataCollectionDismissed",
        value: false,
      });
    },
    hideTrigger() {
      this.setUserPreferences({
        key: "dataCollectionTriggerDismissed",
        value: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.trigger {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background-color: $color-white;
  border: 1px solid $color-black;
  border-radius: 8px 8px 0 0;
  cursor: pointer;

  @include respond-above(md) {
    padding: 16px 20px;
  }
}

.trigger__label {
  @include editorial-headline(14px);
  text-transform: uppercase;
  color: $color-black;
  white-space: nowrap;

  @include respond-above(md) {
    @include editorial-headline(16px);
  }
}

.trigger__close {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: $color-black;

  .icon {
    font-size: 12px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
